<template>
  <div class="atividades-monitoramentoescala ml-4 mr-4">
    <b-form>
      <b-row>
        <b-col cols="1" class="mt-2 pr-4">
          <b-form-group label="" label-for="tabela-foto">
            <b-img
              class="mb-2"
              v-model="operador.foto_url"
              v-bind="mainProps"
              rounded
              alt="Foto"
              :src="operador.foto_url"
            >
            </b-img>
          </b-form-group>
        </b-col>

        <b-col>
          <!-- NOME -->
          <b-row>
            <b-col cols="5" class="mt-3">
              <b-form-input
                id="fot-nome"
                type="text"
                readonly
                v-model="operador.nome"
                placeholder="Nome funcionário"
              />
            </b-col>

            <b-col cols="3" class="mt-3">
              <b-form-input
                id="fot-funcao"
                type="text"
                readonly
                v-model="operador.funcao"
                placeholder="Função"
              />
            </b-col>
          </b-row>

          <!-- Resumo -->

          <!-- RE e CELULAR -->
          <b-row>
            <b-col cols="1" class="mt-4">
              <b-form-input
                id="fot-registro"
                type="text"
                required
                v-model="registro"
                @keyup.enter="loadOperador()"
                placeholder="1818"
              />
            </b-col>

            <b-col cols="2" class="mt-4">
              <div>
                <b-form-datepicker
                  id="esc_data_servico"
                  required
                  v-model="data_inicial"
                  placeholder="Data inicial"
                  locale="pt-BR"
                  date-format-options="DD/MM/YYYY"
                ></b-form-datepicker>
              </div>
            </b-col>

            <b-col cols="2" class="mt-4">
              <div>
                <b-form-datepicker
                  id="esc_data_servico2"
                  required
                  v-model="data_final"
                  placeholder="Data final"
                  locale="pt-BR"
                  date-format-options="DD/MM/YYYY"
                ></b-form-datepicker>
              </div>
            </b-col>

            <b-col cols="1" class="mt-4">
              <b-button
                size="sm"
                id="btn-pesquisar"
                variant="primary"
                class="mr-2 mt-2"
                @click="loadFichaPonto()"
              >
                Pesquisar
              </b-button>
            </b-col>

            <LoadingModal v-if="isLoading" />
          </b-row>
        </b-col>
      </b-row>
    </b-form>
    <hr />
    <b-table
      small
      hover
      striped
      sticky-header="762px"
      :items="fichaponto"
      :fields="fields"
    >
    </b-table>

    <b-tfoot>
      <b-tr>
        <b-td width="8%" colspan="4" variant="secondary" class="text-left">
          <b> ** Resumo folha ** </b>
        </b-td>
        <b-td width="1%" colspan="4" variant="secondary" class="text-center">
        </b-td>

        <b-table
          small
          hover
          striped
          sticky-header="550px"
          :items="fichapontoresumofolha"
          :fields="fieldsResumoFolha"
        >
        </b-table>

        <!-- DSR 
        <b-td width="8%" colspan="4" variant="secondary" class="text-left">
          D.S.R: <b>
                            {{
                                fichaponto.DSR =  fichaponto.map( sal => sal.DSR ).reduce(function(anterior,atual){return somarTempos(anterior,atual);},"00:00")
                            }}                           
                        </b>
        </b-td>
        <b-td width="5%" colspan="4" variant="secondary" class="text-right"> </b-td>
-->
      </b-tr>

      <!-- -->
      <b-tr>
        <b-td></b-td>
        <b-td></b-td>
        <b-td></b-td>
        <b-td></b-td>
        <b-td></b-td>
        <b-td></b-td>
      </b-tr>

      <!-- -->
      <b-tr>
        <b-td width="8%" colspan="4" variant="secondary" class="text-left">
          <b> **Banco de horas** </b>
        </b-td>
        <b-td width="5%" colspan="4" variant="secondary" class="text-center">
        </b-td>

        <b-td width="8%" colspan="4" variant="secondary" class="text-left">
          Competência:
          <b>
            {{
              (fichaponto.BH_COMPETENCIA = fichaponto
                .map((sal) => sal.BH_COMPETENCIA)
                .reduce(function (anterior, atual) {
                  return atual;
                }, 0))
            }}
          </b>
        </b-td>
        <b-td width="5%" colspan="4" variant="secondary" class="text-center">
        </b-td>

        <b-td width="8%" colspan="4" variant="secondary" class="text-left">
          Saldo anterior.:
          <b>
            {{
              (fichaponto.SALDOANTERIOR = fichaponto
                .map((sal) => sal.SALDOANTERIOR)
                .reduce(function (anterior, atual) {
                  return atual;
                }, 0))
            }}
          </b>
        </b-td>
        <b-td width="5%" colspan="4" variant="secondary" class="text-center">
        </b-td>

        <b-td width="8%" colspan="4" variant="secondary" class="text-left">
          Crédito.....................:
          <b>
            {{
              (fichaponto.CREDITO = fichaponto
                .map((sal) => sal.CREDITO)
                .reduce(function (anterior, atual) {
                  return atual;
                }, 0))
            }}
          </b>
        </b-td>
        <b-td width="5%" colspan="4" variant="secondary" class="text-center">
        </b-td>

        <b-td width="8%" colspan="4" variant="secondary" class="text-left">
          Débito........:
          <b>
            {{
              (fichaponto.DEBITO = fichaponto
                .map((sal) => sal.DEBITO)
                .reduce(function (anterior, atual) {
                  return atual;
                }, 0.0))
            }}
          </b>
        </b-td>
        <b-td width="5%" colspan="4" variant="secondary" class="text-center">
        </b-td>

        <b-td width="8%" colspan="4" variant="secondary" class="text-left">
          Valor pago.:
          <b>
            {{
              (fichaponto.VALORPAGO = fichaponto
                .map((sal) => sal.VALORPAGO)
                .reduce(function (anterior, atual) {
                  return atual;
                }, 0))
            }}
          </b>
        </b-td>
        <b-td width="5%" colspan="4" variant="secondary" class="text-right">
        </b-td>

        <b-td width="20%" colspan="4" variant="secondary" class="text-left">
          Saldo atual.:
          <b>
            {{
              (fichaponto.SALDOATUAL = fichaponto
                .map((sal) => sal.SALDOATUAL)
                .reduce(function (anterior, atual) {
                  return atual;
                }, "00:00"))
            }}
          </b>
        </b-td>
      </b-tr>
    </b-tfoot>
  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "TraAtividadesProgramadasRealizadas",
  components: { LoadingModal },

  data: function () {
    return {
      mode: "save",

      operadores: {},
      operador: [],

      fichaponto: [],
      fichapontoresumofolha: {},
      fichapontom: [],
      fichapontorm: [],
      data_inicial: "",
      data_final: "",
      mainProps: { blankColor: "#777", width: 157, height: 161, class: "m1" },

      fields: [
        {
          key: "DATA_MOVIMENTO",
          label: "Data Servico",
          sortable: true,
          formatter: (value, key, fichaponto) => {
            return moment(fichaponto.DATA_MOVIMENTO).format("DD/MM/YYYY");
          },
        },
        /*   
                { key: 'LINHA', label: ' LINHA ', sortable: true },                 
                { key: 'TABELA', label: ' TABELA ', sortable: true },                                 
            */
        { key: "ENTRADA", label: " ENTRADA ", sortable: true },
        { key: "I_INI", label: " I_INI ", sortable: true },
        { key: "I_FIM", label: " I_FIM ", sortable: true },
        { key: "SAIDA", label: " SAIDA ", sortable: true },
        //  { key: 'CODOCORR', label: ' Código ocorrência ', sortable: true },
        { key: "NORMAL", label: " NORMAL ", sortable: true },
        { key: "EXTRA", label: " EXTRA ", sortable: true },
        { key: "A_NOT", label: " A_NOT ", sortable: true },
        { key: "OUTRA", label: " OUTRA ", sortable: true },
        { key: "BD_DEBITO", label: " DEBITO ", sortable: true },
        { key: "BD_CREDITO", label: " CREDITO ", sortable: true },
        /*
                { key: 'OUTRA', label: ' OUTRA ', sortable: true }, 
                { key: 'DSR', label: ' D.S.R ', sortable: true },                 
                { key: 'USUDIGIT', label: ' Digitado por ', sortable: true }, 
                { key: 'DTDIGITDIGIT', label: 'Data da Digitação', sortable: true, formatter: (value, key, fichaponto) => {
                    return moment(fichaponto.DTDIGITDIGIT).format('DD/MM/YYYY HH:mm').replace('Data inválida','-');} },                
                    */
      ],

      fieldsResumoFolha: [
        {
          key: "EVENTO",
          label: " __________________EVENTO__________________ ",
          sortable: true,
          height: 480,
        },
        { key: "HR_FORMATADA", label: " HR_DIA ", sortable: true },
      ],
    };
  },

  computed: mapState(["user"]),
  methods: {
    async loadOperador() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        registro: `${this.registro}`,
        id_empresa: `${this.user.id_empresa}`,
      };

      const url = `${baseApiUrl}/glo/escala/consulta/`;
      axios.get(url, { params }).then((res) => {
        this.operador = res.data;
      });
      this.fichaponto = [];
    },

    async loadFichaPonto() {
      let corpo = {
        ID_FUNCIONARIO_ERP: `${this.operador.id_funcionario_erp}`,
        dt_movimento_inicio: this.data_inicial
          ? `${moment(this.data_inicial).format("DD/MM/YYYY")}`
          : null,
        dt_movimento_fim: this.data_final
          ? `${moment(this.data_final).format("DD/MM/YYYY")} `
          : null,
      };

      const url = `${baseApiUrl}/glo/pontoeletronico/ficha`;
      try {
        this.isLoading = true; // Ative o indicador de carregamento
        const res = await axios.post(url, corpo);
        this.fichaponto = res.data;
        this.loadFichaPontoSeparador();
        this.loadFichaPontoResumoFolha();
        this.isLoading = false; // Ative o indicador de carregamento
      } catch (e) {
        // Verificando se o erro tem um statusCode 400
        if (e.response && e.response.status === 404) {
          showError;
          this.isLoading = false; // Ative o indicador de carregamento
        } else {
          this.isLoading = false; // Ative o indicador de carregamento
          showError(e);
        }
      }
    },

    //06/07/2023 23:17h
    async loadFichaPontoResumoFolha() {
      let corpo = {
        ID_FUNCIONARIO_ERP: `${this.operador.id_funcionario_erp}`,
        COMPETENCIA: `${moment(this.data_final).format("MM/YYYY")}`,
      };

      const url = await `${baseApiUrl}/orc/pon/pontoresumofolha`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.fichapontoresumofolha = res.data;
          this.loadFichaPontoSeparadorrm();

          setTimeout(() => {}, 2000);
        })
        .catch(showError);
    },

    loadFichaPontoSeparador(fichaponto) {
      this.fichapontom = { ...fichaponto };
    },

    loadFichaPontoSeparadorrm(fichapontoresumofolha) {
      this.fichapontorm = { ...fichapontoresumofolha };
    },

    somarTempos(tempo1, tempo2) {
      var array1 = tempo1.split(":");
      var tempo_seg1 =
        parseInt(array1[0]) * 3600 +
        parseInt(array1[1]) * 60 +
        parseInt(array1[2]);
      var array2 = tempo2.split(":");
      var tempo_seg2 =
        parseInt(array2[0]) * 3600 +
        parseInt(array2[1]) * 60 +
        parseInt(array2[2]);
      var tempofinal = parseInt(tempo_seg1) + parseInt(tempo_seg2);
      var hours = Math.floor(tempofinal / (60 * 60));
      var divisorMinutos = tempofinal % (60 * 60);
      var minutes = Math.floor(divisorMinutos / 60);
      var divisorSeconds = divisorMinutos % 60;
      var seconds = Math.ceil(divisorSeconds);
      var contador = "";
      if (hours < 10) {
        contador = "0" + hours + ":";
      } else {
        contador = hours + ":";
      }
      if (minutes < 10) {
        contador += "0" + minutes + ":";
      } else {
        contador += minutes + ":";
      }
      if (seconds < 10) {
        contador += "0" + seconds;
      } else {
        contador += seconds;
      }
      return contador;
    },
  },

  beforeCreate() {
    this.somarTempos();
  },

  mounted() {
    //this.somarTempos()
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.table {
  font-size: 0.7em;
}
</style>

